module.exports = __webpack_public_path__ + "img/btn-active.39f71b37.png";